import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

interface AskQuestionRequest {
  question: string
  hotelRequestParams: {
    languageCode: string
    currencyCode: string
    anonymousId: string
    hotelId: string
  }
  conversation: string | null
}

interface AskQuestionResponse {
  answer: string
  conversation: string
}

export const chatbotApi = createApi({
  reducerPath: 'chatbotApi',
  baseQuery: fetchBaseQuery({baseUrl: '/api/hotel/chatBot'}),
  endpoints: builder => ({
    askQuestion: builder.query<AskQuestionResponse, AskQuestionRequest>({
      query: arg => ({
        url: '/ask',
        method: 'POST',
        body: arg
      })
    })
  })
})

export const {useLazyAskQuestionQuery} = chatbotApi
